/* Modalco hiz katmani (07.10.2026). 1) Sepet bildiriminde "Sepeti goruntule" ve "Odeme" ekleme surerken tiklanabilir; istek bitince yonlendirir. 2) Urun sayfasindan ekleme 1.000 TL esigini gecirecekse hediye maske ayni istekte eklenir. Geri almak icin theme.liquid icindeki modalco-speed.js satirini silmek yeterlidir. */
(function () {
  if (window.__mcSpeed) return;
  window.__mcSpeed = 1;
  var d = document,
    w = window;
  var ROOT = (w.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function U(p) {
    return ROOT.replace(/\/$/, "") + p;
  }
  var st = d.createElement("style");
  st.textContent =
    '#cart-notification.mc-oa .cart-notification__links{opacity:1!important;pointer-events:auto!important}#cart-notification .mc-go{position:relative;pointer-events:none}#cart-notification .mc-go:after{content:"";position:absolute;right:12px;top:50%;width:14px;height:14px;margin-top:-7px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:mcGoSpin .7s linear infinite}@keyframes mcGoSpin{to{transform:rotate(360deg)}}';
  d.head.appendChild(st);
  var go = null,
    added = 0;
  function clearGo() {
    if (go && go.el) {
      go.el.classList.remove("mc-go");
      go.el.removeAttribute("aria-busy");
    }
    go = null;
  }
  var inflight = 0;
  function settle(cb) {
    var t0 = Date.now(),
      ok = 0;
    (function chk() {
      ok = inflight === 0 && (!w.mcCartIdle || w.mcCartIdle()) ? ok + 1 : 0;
      if (ok >= 2 || Date.now() - t0 > 1500) return cb();
      setTimeout(chk, 60);
    })();
  }
  function run(g) {
    go = null;
    settle(function () {
      if (g.t === "cart") {
        location.href = g.h;
        return;
      }
      var f = d.getElementById("cart-notification-form"),
        sb = f && f.querySelector('[name="checkout"]');
      if (!f || !sb) return;
      setTimeout(function () {
        sb.classList.remove("mc-go");
        sb.removeAttribute("aria-busy");
      }, 12e3);
      try {
        f.requestSubmit ? f.requestSubmit(sb) : sb.click();
      } catch (e) {
        sb.click();
      }
    });
  }
  d.addEventListener("mc:added", function () {
    added = 1;
  });
  var curClick = null;
  d.addEventListener(
    "click",
    function (e) {
      curClick = e;
      setTimeout(function () {
        if (curClick === e) curClick = null;
      }, 0);
    },
    true,
  );
  function watch() {
    var b = d.getElementById("cart-notification");
    if (!b || b.__mcSpd) return;
    b.__mcSpd = 1;
    var wasOa = b.classList.contains("mc-oa"),
      wasAct = b.classList.contains("active"),
      oE = null;
    new MutationObserver(function () {
      var oa = b.classList.contains("mc-oa"),
        act = b.classList.contains("active");
      if (oa && !wasOa) {
        added = 0;
        b.__mcUC = 0;
      }
      if (oa) {
        if (wasAct && !act) {
          if (oE && oE === curClick) {
            setTimeout(function () {
              try {
                if (
                  b.classList.contains("mc-oa") &&
                  !b.classList.contains("active")
                )
                  b.closest("cart-notification").open();
              } catch (x) {}
            }, 0);
          } else {
            b.__mcUC = 1;
            clearGo();
          }
        }
        if (!wasAct && act) {
          b.__mcUC = 0;
          oE = curClick;
        }
      }
      if (!oa && wasOa) {
        if (added) {
          if (b.__mcUC) {
            try {
              b.closest("cart-notification").close();
            } catch (e) {}
          }
          if (go) run(go);
        } else clearGo();
        b.__mcUC = 0;
      }
      wasOa = oa;
      wasAct = b.classList.contains("active");
    }).observe(b, { attributes: true, attributeFilter: ["class"] });
  }
  d.addEventListener(
    "click",
    function (e) {
      var b = d.getElementById("cart-notification");
      if (
        !b ||
        !b.classList.contains("mc-oa") ||
        !e.target ||
        !e.target.closest
      )
        return;
      var el = e.target.closest(
        '#cart-notification-button, #cart-notification-form [name="checkout"]',
      );
      if (!el) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      clearGo();
      go = {
        t: el.id === "cart-notification-button" ? "cart" : "ck",
        h: el.getAttribute("href") || U("/cart"),
        el: el,
      };
      el.classList.add("mc-go");
      el.setAttribute("aria-busy", "true");
    },
    true,
  );
  var KK = w.MC_KAMPANYA || {},
    G = (w.MC_PLUS && w.MC_PLUS.gift) || {
      id: 51089419239739,
      at: KK.gift || 1e3,
    };
  /* v6-8: 3 Al 2 Öde ürünleri hediye eşiğine sayılmaz */
  function camp(pid) {
    return (KK.b3 || []).indexOf(+pid) > -1;
  }
  function pagePid() {
    try {
      return w.ShopifyAnalytics.meta.product.id;
    } catch (e) {
      return 0;
    }
  }
  function ss(k) {
    try {
      return sessionStorage.getItem(k) || "";
    } catch (e) {
      return "";
    }
  }
  function isGift(it) {
    return it.variant_id === G.id && !!(it.properties && it.properties._hediye);
  }
  function paid(c) {
    var t = 0,
      n = 0;
    c.items.forEach(function (it) {
      if (!isGift(it)) {
        camp(it.product_id) || (t += it.final_line_price);
        n += it.quantity;
      }
    });
    return { t: t / 100, n: n };
  }
  function sigAdd(c, vid, q) {
    var m = {};
    c.items.forEach(function (it) {
      if (!isGift(it)) m[it.variant_id] = (m[it.variant_id] || 0) + it.quantity;
    });
    m[vid] = (m[vid] || 0) + q;
    return Object.keys(m)
      .sort()
      .map(function (k) {
        return k + ":" + m[k];
      })
      .join("|");
  }
  function qOf(c, vid) {
    var n = 0;
    ((c && c.items) || []).forEach(function (it) {
      if (it.variant_id === vid && !isGift(it)) n += it.quantity;
    });
    return n;
  }
  function variants() {
    try {
      return w.ShopifyAnalytics.meta.product.variants || [];
    } catch (e) {
      return [];
    }
  }
  function price(vid) {
    var v = variants().filter(function (x) {
      return x.id === vid;
    })[0];
    return v ? v.price : null;
  }
  function isCart() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname);
  }
  function avState() {
    try {
      var a = JSON.parse(sessionStorage.getItem("mcGiftAv") || "null");
      return a && Date.now() - a.t < 6e5 ? a : null;
    } catch (e) {
      return null;
    }
  }
  var avBusy = 0;
  function avFetch() {
    if (avBusy || avState()) return;
    avBusy = 1;
    fetch(U("/variants/" + G.id + ".js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (v) {
        if (v) {
          try {
            sessionStorage.setItem(
              "mcGiftAv",
              JSON.stringify({ a: !!v.available, t: Date.now() }),
            );
          } catch (e) {}
        }
      })
      .catch(function () {})
      .then(function () {
        avBusy = 0;
      });
  }
  function maybePrefetch() {
    try {
      var vs = variants(),
        c = w.mcCartLast && w.mcCartLast();
      if (
        !vs.length ||
        !c ||
        !c.items ||
        isCart() ||
        c.items.some(isGift) ||
        ss("mcGiftOff") === "1" ||
        camp(pagePid())
      )
        return;
      var p = paid(c),
        mx = 0;
      vs.forEach(function (v) {
        if (v.price > mx) mx = v.price;
      });
      if (p.n <= 1 && p.t + (mx / 100) * (2 - p.n) >= G.at) avFetch();
    } catch (e) {}
  }
  function plan(url, o) {
    if (
      !o ||
      String(o.method || "").toUpperCase() !== "POST" ||
      !/\/cart\/add(\?|$)/.test(url)
    )
      return null;
    if (
      typeof FormData === "undefined" ||
      !(o.body instanceof FormData) ||
      isCart() ||
      w.__mcTx
    )
      return null;
    var fd = o.body,
      vid = +fd.get("id"),
      q = parseInt(fd.get("quantity"), 10) || 1,
      pr = price(vid);
    if (!vid || vid === G.id || pr == null || q < 1 || camp(pagePid()))
      return null;
    var bad = false,
      props = {},
      has = false;
    fd.forEach(function (v, k) {
      if (k.indexOf("items[") === 0 || k.indexOf("selling_plan") === 0)
        bad = true;
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) {
        props[m[1]] = v;
        has = true;
      }
    });
    if (bad) return null;
    var c = w.mcCartLast && w.mcCartLast();
    if (!c || !c.items || c.items.some(isGift) || ss("mcGiftOff") === "1")
      return null;
    var p = paid(c);
    if (p.n + q > 2 || p.t + (pr * q) / 100 < G.at) return null;
    if (ss("mcGiftBlk2") === sigAdd(c, vid, q)) return null;
    var av = avState();
    if (!av || !av.a) return null;
    var item = { id: vid, quantity: q };
    if (has) item.properties = props;
    return {
      vid: vid,
      q: q,
      item: item,
      sec: String(fd.get("sections") || ""),
      su: String(fd.get("sections_url") || location.pathname),
      c0: c,
    };
  }
  function asResp(obj, s) {
    return new Response(JSON.stringify(obj), {
      status: s || 200,
      headers: { "Content-Type": "application/json" },
    });
  }
  function fix(r, P) {
    var get = w.mcCartGet
      ? w.mcCartGet(true)
      : fetch(U("/cart.js"), { credentials: "same-origin" }).then(function (x) {
          return x.json();
        });
    return Promise.resolve(get)
      .then(function (c) {
        if (qOf(c, P.vid) < qOf(P.c0, P.vid) + P.q) return r;
        var line = c.items.filter(function (it) {
          return it.variant_id === P.vid && !isGift(it);
        })[0];
        if (!line) return r;
        if (!P.sec) return asResp(line);
        return fetch(
          P.su +
            (P.su.indexOf("?") > -1 ? "&" : "?") +
            "sections=" +
            encodeURIComponent(P.sec),
          { credentials: "same-origin" },
        )
          .then(function (x) {
            return x.ok ? x.json() : null;
          })
          .then(function (S) {
            return S ? asResp(Object.assign({}, line, { sections: S })) : r;
          });
      })
      .catch(function () {
        return r;
      });
  }
  function combo(inner, url, P) {
    var body = {
      items: [P.item, { id: G.id, quantity: 1, properties: { _hediye: "1" } }],
    };
    if (P.sec) {
      body.sections = P.sec;
      body.sections_url = P.su;
    }
    var u2 = url.replace(/\/cart\/add(\.js)?(?=\?|$)/, "/cart/add.js");
    return inner
      .call(w, u2, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      })
      .then(function (r) {
        return r
          .clone()
          .json()
          .then(
            function (j) {
              var pl =
                r.ok && j && j.items
                  ? j.items.filter(function (it) {
                      return it.variant_id === P.vid && !isGift(it);
                    })[0]
                  : null;
              if (pl)
                return asResp(
                  Object.assign(
                    {},
                    pl,
                    j.sections ? { sections: j.sections } : {},
                  ),
                );
              return fix(r, P);
            },
            function () {
              return fix(r, P);
            },
          );
      });
  }
  var inner = w.fetch;
  if (typeof inner === "function") {
    w.fetch = function (u, o) {
      var url = typeof u === "string" ? u : (u && u.url) || "",
        P = null;
      try {
        P = plan(url, o);
      } catch (e) {
        P = null;
      }
      var p = P ? combo(inner, url, P) : inner.apply(this, arguments);
      if (
        /\/cart(\.js|\.json)?(\?|$)|\/cart\/(add|change|update|clear)/.test(
          url,
        ) &&
        p &&
        p.then
      ) {
        inflight++;
        var dec = function () {
          inflight = Math.max(0, inflight - 1);
        };
        p.then(dec, dec);
      }
      return p;
    };
  }
  function init() {
    watch();
    setTimeout(maybePrefetch, 1500);
  }
  d.addEventListener("mc:added", function () {
    setTimeout(maybePrefetch, 800);
  });
  d.readyState !== "loading"
    ? init()
    : d.addEventListener("DOMContentLoaded", init);
})();
